const parens = `<span class="svg-text svg-text--code-font">()</span>`
export default parens